export const paginationComponentOptions = {
	rowsPerPageText: "Dados por página",
	rangeSeparatorText: "de",
	selectAllRowsItem: true,
	selectAllRowsItemText: "Todos",
};
